import request from '@/utils/request'

export function fetchUserData(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: '/api/serviceCenter/user/v2/userLogin',
        method: 'post',
        data,
    })

}
